import { jsx as e } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ e(
  "path",
  {
    fill: "#212134",
    d: "M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.53-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685Z"
  }
) }), n = t;
export {
  n as default
};
